import { Grid, Link, Typography } from '@mui/material';
import { type JobSearchResultWithURL } from '@/types/SearchDirectory';
import { useResponsive } from '@/components/hooks/useResponsive';
import { JobSeekerAvatar } from './JobSeekerAvatar';
import { JobTagList } from './JobTagList';

export interface JobOverviewProps {
  searchResult: JobSearchResultWithURL;
}

export const JobOverview = ({ searchResult }: JobOverviewProps) => {
  const { isSmallViewport } = useResponsive();
  const targetValue = isSmallViewport ? undefined : '_blank';

  const {
    seoSegmentationJob: {
      job: { title },
    },
    jobDetailURL,
  } = searchResult;

  return (
    <Grid xs={12} container columnSpacing={isSmallViewport ? 2 : 3}>
      <Grid item>
        <Link variant="h3" underline="none" href={jobDetailURL} target={targetValue}>
          <JobSeekerAvatar
            job={searchResult.seoSegmentationJob}
            isClientSearchResultsQuery={false}
          />
        </Link>
      </Grid>

      <Grid item xs alignContent="flex-start">
        <Typography variant={isSmallViewport ? 'h3' : 'h2'}>{title}</Typography>
        {!isSmallViewport && <JobTagList sx={{ mt: 1 }} job={searchResult.seoSegmentationJob} />}
      </Grid>
    </Grid>
  );
};
